import { AuthApi as BackendAuthApi } from '@EHSNavigator/backend';
import axiosInstance from '../Axios';

const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';

const AuthApi = new BackendAuthApi(undefined, BASE_URL, axiosInstance as any);

export { AuthApi };
